import { render, staticRenderFns } from "./DialogForm.vue?vue&type=template&id=f13fa6c2&"
import script from "./DialogForm.vue?vue&type=script&lang=ts&"
export * from "./DialogForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports